// extracted by mini-css-extract-plugin
export var captionVideo = "media-gallery-module--captionVideo--8373a";
export var imageBox = "media-gallery-module--imageBox--431ea";
export var playVideo = "media-gallery-module--playVideo--63706";